"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tracking = void 0;
const react_1 = __importDefault(require("react"));
const constants_1 = require("../../core/constants");
const script = ({ env, profile, config }) => `
window.utag_cfg_ovrd = ${JSON.stringify(config)};
(function(a,b,c,d){
  a='//tags.tiqcdn.com/utag/kingfisher/${profile}/${env}/utag.js';
  b=document;c='script';d=b.createElement(c);d.src=a;d.id='${constants_1.trackingScriptId}';d.type='text/java'+c;d.async=true;
  a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a);
})();
`;
const Tracking = ({ env, profile, config, }) => {
    react_1.default.useEffect(() => {
        const scriptTag = document.createElement('script');
        scriptTag.async = true;
        scriptTag.text = script({ env, profile, config });
        document.body.appendChild(scriptTag);
        return () => {
            document.body.removeChild(scriptTag);
        };
    }, []);
    return null;
};
exports.Tracking = Tracking;
